import React, { useState } from 'react';
import { apiService } from '../services/api';

const RechargeModal = ({ isOpen, onClose, member, onRechargeSuccess }) => {
  const [amount, setAmount] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!amount || parseFloat(amount) <= 0) {
      setError('Bitte geben Sie einen gültigen Betrag ein');
      return;
    }

    setIsLoading(true);
    setError(null);

    try {
      const response = await apiService.rechargeCredit(parseFloat(amount));
      console.log('Recharge erfolgreich:', response.data);
      onRechargeSuccess(response.data.new_balance);
      onClose();
    } catch (error) {
      console.error('Recharge-Fehler:', error);
      setError(error.response?.data?.error || 'Fehler beim Aufladen des Guthabens');
    } finally {
      setIsLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-2xl p-6 w-full max-w-md shadow-lg">
        <h2 className="text-2xl font-bold text-wood-800 mb-4">Guthaben aufladen</h2>
        
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-wood-700 mb-3">
              Betrag auswählen
            </label>
            
            {/* Preset Buttons */}
            <div className="grid grid-cols-2 gap-3 mb-4">
              {[5, 10, 20, 50].map((preset) => (
                <button
                  key={preset}
                  type="button"
                  onClick={() => setAmount(preset.toString())}
                  className={`py-3 px-4 rounded-lg font-semibold transition-all duration-200 ${
                    amount === preset.toString()
                      ? 'bg-beer-600 text-white shadow-lg transform scale-105'
                      : 'bg-wood-100 text-wood-700 hover:bg-wood-200 hover:shadow-md'
                  }`}
                >
                  {preset}€
                </button>
              ))}
            </div>
            
            {/* Custom Amount */}
            <div>
              <label htmlFor="amount" className="block text-sm font-medium text-wood-700 mb-2">
                Oder eigenen Betrag eingeben
              </label>
              <input
                id="amount"
                type="number"
                step="0.01"
                min="0.01"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                className="w-full px-3 py-2 border border-wood-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-beer-500 focus:border-transparent"
                placeholder="0.00"
                required
              />
            </div>
          </div>
          
          {error && (
            <div className="bg-red-50 border border-red-200 rounded-lg p-3">
              <p className="text-red-600 text-sm">{error}</p>
            </div>
          )}
          
          <div className="flex space-x-3">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 bg-wood-200 hover:bg-wood-300 text-wood-800 font-semibold py-3 px-4 rounded-lg transition-colors duration-200"
            >
              Abbrechen
            </button>
            <button
              type="submit"
              disabled={isLoading}
              className="flex-1 btn-primary disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isLoading ? (
                <div className="flex items-center justify-center">
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                  Lädt...
                </div>
              ) : (
                'Aufladen'
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RechargeModal;
